<script>
  import {onMount, getContext} from 'svelte';
  import Carousel from './Carousel.svelte';
  import {env, envUtil} from '@/helper/env';
  import {sd} from '@/da';
  import {lang$} from '@/store/lang';
  import {innerWidth$} from '@/streams/window-inner-size';
  import {genSystemDevice} from '@/helper/device';
  import {query$, bannerList$} from '../streams';

  let marqId = 0;
  let timer = null;
  let marqWrap = null;
  let scroller = null;
  let scrollerTransaction = 'all 0.1s';

  const LG = getContext('LG');

  onMount(() => {
    query$.next({itemKey: 'banner', lang: $lang$, location: 1, device: genSystemDevice()});
  });

  $: bannerList = $bannerList$.list;
  $: bannerLoading = $bannerList$.loading;
  $: marquee = bannerList.length > 0 ? [...bannerList, bannerList[0]] : [];
  $: autoPlay(marquee);
  $: perCount = envUtil.isMobile ? 1 : 3;
  $: scrollHeight = envUtil.isMobile ? 16 : 18;

  function autoPlay(marq) {
    if (timer) {
      clearInterval(timer);
    }
    if (marq.length > 2) {
      timer = setInterval(() => {
        const bool = marqId >= marq.length - 1;
        scrollerTransaction = 'all 0.2s';
        marqId = bool ? 0 : marqId + 1;
        if (marqId >= marq.length - 1) {
          setTimeout(() => {
            scrollerTransaction = 'all 0';
            marqId = 0;
          }, 1000);
        }
      }, 8000);
    }
  }

  function promotionClickHandler(item, index) {
    return function (e) {
      e.preventDefault();
      handleBannerClick(item, index);
      location.href = item.detail.webLink;
    };
  }

  function handleBannerClick(item, index) {
    const isMobileOrApp = env.isMobile || env.isApp;
    sd.track('banner_click', {
      banner_index: index,
      banner_url: item.detail.webLink,
      banner_lang: item.lang,
      banner_source_page: 'home',
      scene_type: item.detail.sceneType,
      banner_label: item.detail.bannerLabel,
      platform: isMobileOrApp ? (env.isMobile ? 'H5' : 'app_h5') : 'Web',
    });
  }
</script>

<style>
  .wrap {
    margin: 0 auto;
    width: 1200px;
  }
  .wrap:hover :global(.left),
  .wrap:hover :global(.right) {
    display: flex;
  }
  .wrap :global(.dots .dot) {
    width: 16px;
  }
  .card {
    box-sizing: border-box;
    padding: 8px 10px;
    width: 100%;
    max-width: 400px;
  }
  .card img {
    border: 1px solid #454952;
    border-radius: 20px;
    width: 100%;
  }

  .marquee-wrap {
    margin: 40px auto 0;
    box-sizing: border-box;
    width: 1200px;
  }
  .marquee-wrap > a {
    border-left: 1px solid #e2e4e9;
    padding-left: 12px;
    white-space: nowrap;
  }
  .marquee {
    margin: 0 12px;
    height: 18px;
    line-height: 18px;
    overflow: hidden;
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;
  }
  .marquee::-webkit-scrollbar {
    width: 0;
  }
  .maq-item {
    scroll-snap-align: start;
  }
  .maq-item .desc {
    height: 16px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .iconfont.left {
    transform: rotate(90deg);
  }
  .iconfont.right {
    transform: rotate(-90deg);
  }
  .wrap :global(.dots) {
    margin-top: 6px !important;
  }
  .wrap :global(.dots .dot) {
    margin: 0 3px !important;
    border-radius: 3px !important;
    width: 6px !important;
    height: 6px !important;
    background: #525356 !important;
    cursor: pointer;
  }
  .wrap :global(.dots .dot.dot-active) {
    width: 24px !important;
    background: #fff !important;
  }
  .c-gray {
    color: #888b94;
  }
  @media screen and (max-width: 640px) {
    .wrap {
      width: 100%;
    }
    .card {
      max-width: initial;
    }
    .marquee-wrap {
      padding: 0 16px;
      width: 100%;
    }
    .marquee {
      flex: 1;
    }
  }
</style>

<div class="wrap">
  {#if bannerList.length > 0 && !bannerLoading}
    {#if bannerList.length > 3 || envUtil.isMobile}
      <Carousel dots={true} perPage={perCount} controls={true} draggable={$innerWidth$ <= 640}>
        <i class="iconfont left df aic jcc f36 cp c-gray" slot="left-control">&#xe623;</i>
        <i class="iconfont right df aic jcc f36 cp c-gray" slot="right-control">&#xe623;</i>
        {#each bannerList as i, index}
          <div class="card tc cp" on:click={promotionClickHandler(i, index)}>
            <img width="100%" src={i.detail.webimg} alt={i.detail.webBannerAlt} />
          </div>
        {/each}
      </Carousel>
    {:else}
      <div class="df aic">
        {#each bannerList as i}
          <div class="card tc cp">
            <img width="100%" src={i.detail.webimg} alt={i.detail.webBannerAlt} />
          </div>
        {/each}
      </div>
    {/if}
  {/if}
</div>
